<template>
  <div class="top-menu">
    <ul class="top-menu-list">
      <li v-for="(item, index) in menuRouter.slice(0, -2)"
          :key="index"
          @mouseenter="handleMouseEnter(item.name)"
          @mouseleave="handleMouseLeave">
        <!-- && item.name!='news' -->
        <router-link v-if="item.name != 'originality'"
                     tag="a"
                     class="top-m-item"
                     :to="item">{{ item.meta.title }}
        </router-link>
        <!-- <a @click="click" v-if="item.name=='news'"
                   :class="{'active':originalityDir}"
                   class="top-m-item">{{item.meta.title}}</a> -->
        <a v-if="item.name == 'originality'"
           :class="{ 'active': originalityDir }"
           class="top-m-item">{{ item.meta.title }}</a>
        <div v-if="item.name == 'originality'"
             class="second-menu"
             :style="boxDisplay"
             @mouseenter="keepMenuOpen"
             @mouseleave="handleMenuLeave">
          <div class="project-status-p">
            <!-- 添加搜索框 -->
            <div class="search-box">
              <el-input
                  v-model="searchKeyword"
                  placeholder="请输入项目名称进行搜索"
                  clearable
                  size="mini"
                  @input="handleSearch"
                  @focus="keepMenuOpen"
                  @click.native.stop
              >
                <i slot="prefix" class="el-icon-search"></i>
              </el-input>
            </div>

            <div class="status-text-p">
              <span>项目状态：</span>
            </div>
            <div class="status1-p status-p">
              <span class="disc-p"></span>
              <span>施工中</span>
            </div>
            <div class="status3-p status-p">
              <span class="disc-p"></span>
              <span>竣工中</span>
            </div>
            <div class="status4-p status-p">
              <span class="disc-p"></span>
              <span>决算中</span>
            </div>
            <div class="status2-p status-p">
              <span class="disc-p"></span>
              <span>已结案</span>
            </div>
          </div>
          <div class="second-menu-inner">
            <div class="second-m-box">
              <div class="second-m-row"
                   v-for="(jxj, i) in jxjSubMenu.parents"
                   :key="i">
                <h4 class="second-label">
                  {{ jxj.parentName }}
                  <i class="second-arrow-icon"></i>
                </h4>
<!--                <div class="second-info">-->
<!--                  <a tag="a"-->
<!--                     @click="jianOn(child.id)"-->
<!--                     v-for="(child, c) in jxjSubMenu.projectLogs"-->
<!--                     :key="c"-->
<!--                     v-if="jxj.id == child.parentId"-->
<!--                     class="second-item"-->
<!--                     :class="getClass(child.forumStatus)">-->
<!--                    <span class="disc-p"></span>-->
<!--                    <span>{{ child.title }}</span>-->
<!--                  </a>-->
<!--                </div>-->
                <div class="second-info">
                  <a tag="a"
                     @click="jianOn(child.id)"
                     v-for="(child, c) in filteredProjectLogs"
                     :key="c"
                     v-if="jxj.id == child.parentId"
                     class="second-item"
                     :class="getClass(child.forumStatus)">
                    <span class="disc-p"></span>
                    <span>{{ child.title }}</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="second-button">
              <!--                            新添加申请-->
              <!-- <span class="dm-btn dm-btn-default" @click="dialogVisible = true">创建订单前流程</span> -->
              <!-- <span class="dm-btn dm-btn-default"
                    style="margin-right: 10px;"
                    @click="goApply2">创建告知函</span> -->
              <span class="dm-btn dm-btn-default"
                    @click="goApply">申请匠心记</span>

            </div>
          </div>
        </div>
      </li>
    </ul>
    <!--        //弹出层-->
    <el-dialog id="my-dialog"
               :append-to-body="true"
               title="请选择您需要的流程"
               :visible.sync="dialogVisible"
               width="600px"
               center>
      <span slot="footer"
            class="dialog-footer">
        <el-button class="el-button-primary">填写项目信息</el-button>
        <el-button class="el-button--danger"
                   @click="goToApply">创建订单前流程</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getJxjList } from '../../api/index.js';
import { menuRouter } from '../../router.js';
import './header-menu.css'

export default {
  name: 'headerMenu',
  data () {
    return {
      boxDisplay: 'display: none',//默认隐藏
      jxjSubMenu: {},
      menuRouter: menuRouter,
      originalityDir: 0,
      dialogVisible: false,
      searchKeyword: '', // 搜索关键词
      filteredProjectLogs: [], // 过滤后的项目日志列表
      shouldKeepMenuOpen: false,  // 添加标志位控制菜单是否保持打开
      currentHoverMenu: ''  // 记录当前悬停的菜单项
    };
  },
  methods: {
    // 处理鼠标进入菜单项
    handleMouseEnter(menuName) {
      this.currentHoverMenu = menuName;
      if (menuName === 'originality') {
        this.boxDisplay = '';
      }
    },

    // 处理鼠标离开菜单项
    handleMouseLeave() {
      if (!this.shouldKeepMenuOpen) {
        this.boxDisplay = 'display: none';
      }
    },

    // 处理菜单内部鼠标离开
    handleMenuLeave() {
      this.shouldKeepMenuOpen = false;
      if (this.currentHoverMenu !== 'originality') {
        this.boxDisplay = 'display: none';
      }
    },

    //保持菜单打开
    keepMenuOpen() {
      this.shouldKeepMenuOpen = true;
      this.boxDisplay = '';
    },

    // 新增搜索方法
    handleSearch () {
      if (!this.jxjSubMenu.projectLogs) {
        this.filteredProjectLogs = [];
        return;
      }

      // 模糊查询逻辑：不区分大小写
      const keyword = this.searchKeyword.toLowerCase().trim();
      if (!keyword) {
        // 如果搜索词为空，显示全部
        this.filteredProjectLogs = this.jxjSubMenu.projectLogs;
        return;
      }

      // 过滤出标题包含关键词的项目
      this.filteredProjectLogs = this.jxjSubMenu.projectLogs.filter(item =>
          item.title && item.title.toLowerCase().includes(keyword)
      );
    },
    // click(){
    //     location.href="https://www.iduilv.com/spc/news"
    // },
    jianOn (id) {
      let routeData = this.$router.resolve({ name: 'jxjDetail', params: { id: id } });
      window.open(routeData.href, '_blank');
    },
    onshowBox () {
      this.boxDisplay = 'display: none'
      setTimeout(() => {
        this.boxDisplay = ''
      }, 100)
    },
    async getJxjList () {
      let res = await getJxjList();
      if (res.Type == 'Success') {
        this.jxjSubMenu = res.Data;
        this.filteredProjectLogs = this.jxjSubMenu.projectLogs || [];
      }
      // this.jxjSubMenu = res;
      // console.log(res);
    },

    goToApply () {   //新添加申请
      this.dialogVisible = false;
      this.$router.push({ name: 'inForm' });
    },

    goApply () {
      this.$router.push({ name: 'jxjApply' });
    },
    goApply2 () {
      this.$router.push({ name: 'jxjCreate' });
    },
    getClass (status) {
      switch (status) {
        case 1:
          return "status1-p";
        case 2:
          return "status2-p";
        case 3:
          return "status3-p";
        case 4:
          return "status4-p";
      }
    }
  },
  created () {
    this.getJxjList();

  },
  watch: {
    $route (to, from) {
      if (location.href.indexOf('originality') > -1) {
        this.originalityDir = 1;
      } else {
        this.originalityDir = 0;
      }
    },

    // 监听项目日志变化，重新过滤
    'jxjSubMenu.projectLogs' (newVal) {
      this.handleSearch();
    }
  }
};
</script>


<style>
.el-input .el-input__inner::placeholder {
  font-size: 12px !important;
}

</style>

<style scoped>
/* 添加搜索框样式 */
.search-box {
  margin-right: 20px;
}

/* 确保搜索框宽度合适 */
::v-deep .search-box .el-input {
  width: 100%;
  max-width: 500px;
}
</style>
